<template>
	<svg
		class="divider-line"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 880 4"
		preserveAspectRatio="xMidYMax slice"
	>
		<g id="divider-line-left">
			<polygon class="cls-1" points="40 2 40 0 0 0 2 2 40 2" />
			<polygon class="cls-3" points="2 2 0 4 40 4 40 2 2 2" />
			<polygon class="cls-2" points="0 0 0 4 2 2 0 0" />
		</g>
		<g id="divider-line-middle">
			<rect class="cls-1" x="40" width="800" height="2" />
			<rect class="cls-3" x="40" y="2" width="800" height="2" />
		</g>
		<g id="divider-line-right">
			<polygon class="cls-2" points="880 0 880 4 878 2 880 0" />
			<polygon class="cls-3" points="840 4 880 4 878 2 840 2 840 4" />
			<polygon class="cls-1" points="878 2 880 0 840 0 840 2 878 2" />
		</g>
	</svg>
</template>

<style lang="scss" scoped>
.divider-line {
	flex-shrink: 0;
	width: 100%;
}

.cls-1 {
	fill: #edd091;
}
.cls-2 {
	fill: #c4951e;
}
.cls-3 {
	fill: #63451a;
}
</style>
